import { processType } from '../../config/Enum/ProcessingModal';
import {
  GetRedirectUrlRequest,
  GetRedirectUrlResponse,
  RedirectReason,
} from '../../proto/out/ir/uid/services/session_api';
import { SET_MULTIPLE } from '../../redux/handleProcessingModal/ProcessingModal';
import { dynamicApi } from '../../_api/services/dynamicApi';
import { setResponseContext } from '../../redux/handleResponseContext/ResponseContext';

export default function BusinessRedirectUser(
  redirectBusinessNavigationURI: any,
  redirectBusinessNextStepToken: any,
  redirectReason: RedirectReason,
  dispatch: any,
  setRedirectUrl: any = null,
) {
  const handleProcessingModal = (processingModal: boolean, processType: string) => {
    dispatch({
      type: SET_MULTIPLE,
      payload: {
        processingModal: processingModal,
        processType: processType,
      },
    });
  };
  const handleResponseContext = (responseContext: any) => {
    dispatch(setResponseContext(responseContext));
  };

  // redux
  handleProcessingModal(true, processType.WAITING);
  const GetValueGetRedirectUrlRequest: GetRedirectUrlRequest = GetRedirectUrlRequest.fromJSON({
    requestContext: { pwaInfo: { stepToken: redirectBusinessNextStepToken } },
    reason: redirectReason,
  });

  dynamicApi({
    request: GetRedirectUrlRequest,
    response: GetRedirectUrlResponse,
    getValueFromRequest: GetValueGetRedirectUrlRequest,
    dispatch,
    method: redirectBusinessNavigationURI,
    onResponseContext: handleResponseContext,
    setRedirectUrl,
  });
}
